export enum LinkType {
  STANDALONE = 'standalone',
  ANCHOR = 'anchor',
  BACK = 'back',
  BUTTON = 'button',
  SHOWMORE = 'showmore',
  SHOWMORE_ICON = 'showmoreicon',
}
